import { isEmpty, isObject, isNull } from "lodash";

const formatNumberData = (data, formatOptions, formatLocale) => {

  let number = data.value;
  if (isObject(number)) {
    number = parseInt(number);
  }
  const options = formatOptions ? formatOptions : {
    maximumFractionDigits: 2
  };

  const locale = formatLocale ? formatLocale : "en";

  if (isNaN(number)) {
    return NaN;
  }

  return new Intl.NumberFormat(locale, options).format(number);
}

const formatNumber = (number, formatOptions, formatLocale) => {

  if (isObject(number)) {
    number = parseInt(number);
  }

  const options = formatOptions ? formatOptions : {
    maximumFractionDigits: 3
  };

  const locale = formatLocale ? formatLocale : "en";

  if (typeof number === 'bigint') {
    number = Number(number); // 또는 .toString() 등 안전하게 변환
  }

  if (isNaN(number) || isNull(number)) {
    return NaN;
  }

  return new Intl.NumberFormat(locale, options).format(number);
}

const formatNumberByAvg = (number, average, digits = 1) => {
  if (isNaN(number)) {
    return NaN;
  }

  const criteria = Math.abs(average);
  if (criteria >= 1e3 && criteria < 1e6) { return `${(number / 1e3).toFixed(digits).replace(/\.0$/, '')}K`; }
  if (criteria >= 1e6 && criteria < 1e9) { return `${(number / 1e6).toFixed(digits).replace(/\.0$/, '')}M`; }
  if (criteria >= 1e9) { return `${(number / 1e9).toFixed(1).replace(/\.0$/, '')}B`; }

  return formatNumber(number);
}

const getNumberFormatterByAvg = (average, digits = 1) => {
  let formatter = number => formatNumber(number);

  const criteria = Math.abs(average);
  if (criteria >= 1e3 && criteria < 1e6) { formatter = number => `${(number / 1e3).toFixed(digits).replace(/\.0$/, '')}K`; }
  if (criteria >= 1e6 && criteria < 1e9) { formatter = number => `${(number / 1e6).toFixed(digits).replace(/\.0$/, '')}M`; }
  if (criteria >= 1e9) { formatter = number => `${(number / 1e9).toFixed(digits).replace(/\.0$/, '')}B`; }

  return formatter;
}

const getMaxValueForChart = (numberArry) => {
  if (isEmpty(numberArry)) return "auto";
  let maxValue = Math.max(...numberArry);
  maxValue = isNaN(maxValue) ? "auto" : maxValue.toFixed(0);

  const firstDigit = parseInt(maxValue.toString()[0]);
  const power = maxValue.toString().length - 1;

  const maxPow = firstDigit * Math.pow(10, power);
  if (maxValue > maxPow) {
    const minus = maxValue - maxPow;
    if (minus > maxPow * 0.2) {
      return (firstDigit + 1) * Math.pow(10, power);
    }
  }
  return maxPow + (maxPow * 0.2);
}

const decimalAdd = (a, b, n = 1) => {
  return Number((Number(a) + Number(b)).toFixed(n));
}

const numberUtil = {
  formatNumberData,
  formatNumber,
  formatNumberByAvg,
  getNumberFormatterByAvg,
  getMaxValueForChart,
  decimalAdd,
};

export default numberUtil;